export default __webpack_public_path__ + "static/ENG_Step_4-9972fe2ca76e1588212d9535e0aee43b.svg";